export default __webpack_public_path__ + "static/media/background-course.7ca7ea4a.png";